export const EDITABLE_COMBO_BOX_CLASSNAME_PREFIX = 'editable-combo-box';
export const EDITABLE_COMBO_BOX_MENU = `${EDITABLE_COMBO_BOX_CLASSNAME_PREFIX}-menu`;
